module.exports = __webpack_public_path__ + "images/images/Goober_leaps-1a13fb87beab7dcef940d7b4e88ed39b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Goober_leaps.jpg
// module id = 2523
// module chunks = 2